module.exports = __webpack_public_path__ + "static/media/quick-view.6ce89426.svg";